import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="form"
export default class extends Controller {
  connect() {
    let form = this.element;

    form.addEventListener('submit', function (event) {
      if (!form.checkValidity()) {
        event.preventDefault()
        event.stopPropagation()
      }
      form.classList.add('was-validated')
      form.requestSubmit()
    }, false)

    // first clear the event listener
    form.removeEventListener('turbo:submit-end', this.next);
    // then add it again
    form.addEventListener('turbo:submit-end', this.next);
  }

  next(event) {
    // if (event.detail.success) {
    const fetchResponse = event.detail.fetchResponse;
    const url = fetchResponse.response.url;

    if (fetchResponse.response.redirected) {
      window.history.pushState(
        { turbo_frame_history: true },
        "",
        url
      );
      // window.Turbo.visit(url);
    }
    // }
  }
}

